import BankAccountDetailsDirective from './BankAccountDetailsDirective';
import CreditCardDetailsDirective from './CreditCardDetailsDirective';
import 'underscore';

export default angular.module('edge.platform.paymentdetails', []).directive('gwPlBankAccountDetails', BankAccountDetailsDirective).directive('gwPlCreditCardDetails', CreditCardDetailsDirective);


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/paymentdetails/module.js
// module id = 1056
// module chunks = 0